import EntityModeTableCellContent from '#components/pages/Components/support/tables/support/EntityModeTableCellContent/EntityModeTableCellContent.jsx';

export default EntityModeTableCellContent;
